export interface PatientAccountData {
	['Subscriptions__r']: {
		records: Array<string>
	}
	['Cases']: {
		records: {}
	}
}

export interface PatientAccountDataState {
	records: Array<PatientAccountData>
}

export enum PATIENT_ACCOUNT_DATA_ACTION_TYPES {
	PATIENT_ACCOUNT_DATA = 'PATIENT_ACCOUNT_DATA',
}

export interface PatientAccountDataSetAction {
	type: PATIENT_ACCOUNT_DATA_ACTION_TYPES.PATIENT_ACCOUNT_DATA
	payload: Array<PatientAccountData>
}

export type PatientAccountDataActions = PatientAccountDataSetAction
